import React, { useState } from 'react';
import { Spin } from 'antd';
import BaseTable from '../../../components/BaseTable';
import StatusTag from '../../../components/ui/StatusTag';
import { MaterialStatus } from '../../../types';

const MaterialStatusTable = ({
  data,
  isLoading,
}: {
  data: MaterialStatus[] | undefined;
  isLoading: boolean;
}) => {
  const [spinning] = useState<boolean>(false);

  const columns = [
    {
      title: 'P.O. Number',
      dataIndex: 'pono',
    },
    {
      title: 'Order Date',
      dataIndex: 'orderDate',
    },
    {
      title: 'Required Date',
      dataIndex: 'requiredDate',
    },
    {
      title: 'Received Date',
      dataIndex: 'rrDate',
    },
    {
      title: 'Delivery Status',
      dataIndex: 'status',
      render: (_text: any, record: MaterialStatus) => (
        <StatusTag status={record.status} />
      ),
    },
  ];

  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <BaseTable
        dataSource={data || []}
        isLoading={isLoading}
        columns={columns}
        module={'Material Status'}
      />
    </>
  );
};

export default MaterialStatusTable;
